import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core'

@Directive({
    selector: '[appFileDropZone]',
})
export class FileDropZoneDirective {
    @HostBinding('class.file-over') fileOver = false

    @Output() fileDropped = new EventEmitter<FileList | undefined>()

    @HostListener('dragenter', ['$event']) onDragStart(): void {
        this.fileOver = true
    }

    @HostListener('dragover', ['$event']) onDragOver(e: DragEvent): void {
        // this is required to prevent the browser from opening the file
        e.preventDefault()
    }

    @HostListener('dragleave', ['$event']) onDragLeave(): void {
        this.fileOver = false
    }

    @HostListener('drop', ['$event']) onDrop(e: DragEvent): void {
        // this is required to prevent the browser from opening the file
        e.preventDefault()
        this.fileOver = false
        this.fileDropped.emit(e.dataTransfer?.files)
    }
}
